/* Component in the Callsheet component to display the Callsheet 
   Department and Important Notes */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";

const NotesPage = (props) => {
    const {important_info, transport_info, department_info, setShow} = props;
  return (
    <div className='mt-3'>
    {/* Important Notes */}
    <div>
    <div className='d-block d-md-none'>
    <div className={`mt-0 mb-3 text-center ${styles.SubTitle }`}>
    <span className={`float-right ${styles.Close }`} onClick={() => setShow(false) } >Close</span> 
    <h4 className={`pl-5 text-center ${styles.Bold }`} 
    style={{ textTransform: 'uppercase'}} > Notes</h4>
    </div>
    </div>
    <h4 className={`mt-3 pl-3 py-0 px-1 ${styles.SubTitleSpan }`} 
    style={{ textTransform: 'uppercase' }}>Important Notes</h4>
    <Row className='px-3'>
        <Col className={`px-1 ${styles.Border3 }`}>
        <p className={`px-1 pt-2 pb-2`}>{important_info} </p>
        </Col>
    </Row>
    </div>
    {/* TRANSPORT NOTES */}
    <div className='mt-5'>
        <h4 className={`pl-3 py-0 px-1 ${styles.SubTitleSpan }`}
         style={{ textTransform: 'uppercase' }}>Transport Notes</h4>
        <Row className='px-3'>
            <Col className={`px-1 ${styles.Border3 }`}>
            <p className={`px-1 pt-2 pb-2`}>{transport_info} </p>
            </Col>
        </Row>
    </div>
    {/* Department Notes */}
    <div className='mt-5'>
    <h4 className={`pl-3 py-0 px-1 ${styles.SubTitleSpan }`} 
    style={{ textTransform: 'uppercase' }}>Department Notes</h4>
    <Row className='px-3'>
        <Col className={`px-1 ${styles.Border3 }`}>
        <p className={`px-1 pt-2 pb-2`}>{department_info} </p>
        </Col>
    </Row>
    </div>
    </div>
  )
}

export default NotesPage